import { render, staticRenderFns } from "./ListPackagePermissions.vue?vue&type=template&id=0b9384fd"
import script from "./ListPackagePermissions.vue?vue&type=script&lang=js"
export * from "./ListPackagePermissions.vue?vue&type=script&lang=js"
import style0 from "./ListPackagePermissions.vue?vue&type=style&index=0&id=0b9384fd&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports